import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(public auth: AuthService) {
    //
  }

  ngOnInit() {
    // if (!this.auth.authenticated()) {
    //   this.auth.login();
    // }
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/login/login.component.ts